import moment from "moment";

export const INITIAL_STATE = {
  invoice_no: "",
  invoice_total: 0,
  slot_id: null,
  opd: { id: null, opd_number: "", date: moment().format("DD MMMM YYYY") },
  invoice_date: "",
  status: "draft",
  admission_details: {
    admission_date: "",
    admission_time: "",
    discharge_date: "",
    discharge_time: "",
    IPD_No: "",
    ipd_id: null,
    injury_no: "",
  },
  discount: 0,
  discount_type: "percentage",
  patient_details: {
    id: null,
    full_name: "",
    phone: "",
  },
};
